<div class="list-page kapea" style="max-width: 1200px">
  <h2 class="header">Logit</h2>

  <form novalidate>
    <div class="ylaosan-kontrollit" style="margin: 0; justify-content: space-between; align-items: center">
      <div class="hakukontrollit" style="align-items: baseline">
        <!--Rajaa kirjanpitajan mukaan-->
        <mat-form-field style="width: 200px; margin-right: 20px">
          <mat-label>Rajaa kirjanpitäjän mukaan</mat-label>
          <mat-select [formField]="lomake.kirjanpitajaUid">
            <mat-option value="all">Kaikki kirjanpitäjät</mat-option>
            @for (kirjanpitaja of kirjanpitajienNimitiedotObservable | async; track kirjanpitaja) {
              <mat-option [value]="kirjanpitaja.avain"> {{ kirjanpitaja.etunimi }} {{ kirjanpitaja.sukunimi }} </mat-option>
            }
          </mat-select>
        </mat-form-field>

        <!--Asiakas-->
        <mat-form-field style="width: 200px; margin-right: 20px">
          <mat-label>Valitse asiakas</mat-label>
          <mat-select [formField]="lomake.asiakasAvain" [compareWith]="compareFn">
            @if (valittuAsiakas) {
              <mat-option [value]="valittuAsiakas.k" class="custom-option"> {{ valittuAsiakas.n }}</mat-option>
            }
            <mat-option value="all" class="custom-option">Kaikki asiakkaat</mat-option>
            <mat-option value="search" class="custom-option">Etsi asiakasta</mat-option>
          </mat-select>
        </mat-form-field>

        <!--Tyyppi-->
        <mat-form-field style="width: 160px; margin-right: 20px">
          <mat-label>Tyyppi</mat-label>
          <mat-select [formField]="lomake.eventType" (selectionChange)="onTypeChange($event)">
            <mat-option value="all">Kaikki tyypit</mat-option>
            <mat-option value="navigoi">Katsoi tietoja (navigoi)</mat-option>
            <mat-option value="klikkasi toimintoa">Klikkasi toimintoa</mat-option>
          </mat-select>
        </mat-form-field>

        <!--Navigointityyli-->
        @if (showNavigationStyle) {
          <mat-form-field style="width: 160px; margin-right: 20px">
            <mat-label>Navigointityyli</mat-label>
            <mat-select [formField]="lomake.navigationMethod">
              <mat-option value="all">Kaikki tavat</mat-option>
              <mat-option value="link/url">URL/Linkki</mat-option>
              <mat-option value="back/forward">Back/forward</mat-option>
            </mat-select>
          </mat-form-field>
        }

        <!--Tehty toiminto-->
        @if (showAction) {
          <mat-form-field style="width: 160px; margin-right: 20px">
            <mat-label>Tehty toiminto</mat-label>
            <mat-select [formField]="lomake.eventName">
              <mat-option value="all">Kaikki toiminnot</mat-option>
            </mat-select>
          </mat-form-field>
        }

        <!--Alkaen/Loppuen-->
        <div style="display: flex; flex-flow: row wrap">
          <mat-form-field style="width: 150px; margin-right: 10px">
            <mat-label>Näytä alkaen</mat-label>
            <input matInput [matDatepicker]="dp1" [formField]="lomake.start" />
            <!-- <mat-hint>Alkaa</mat-hint> -->
            <mat-datepicker-toggle matSuffix [for]="dp1"></mat-datepicker-toggle>
            <mat-datepicker #dp1></mat-datepicker>
          </mat-form-field>
          <mat-form-field style="width: 150px">
            <mat-label>... loppuen</mat-label>
            <input matInput [matDatepicker]="dp2" [formField]="lomake.end" />
            <!-- <mat-hint>Loppuu</mat-hint> -->
            <mat-datepicker-toggle matSuffix [for]="dp2"></mat-datepicker-toggle>
            <mat-datepicker #dp2></mat-datepicker>
          </mat-form-field>
        </div>

        <app-primary-button (click)="haeLogit()" actionId="Hae logit" [actionContext]="[lomake().value()]">Hae</app-primary-button>

        <!--Asiakkaan haku-->
        <div class="search-container">
          @if (lomake.asiakasAvain().value() === 'search') {
            <div style="max-width: 680px">
              <div style="font-size: 18px; margin-bottom: 20px; line-height: 20px; margin-top: 45px; text-align: center; color: #0a2731">Valitse asiakas</div>
              <div style="margin-left: 10px; margin-right: 10px">
                <mat-form-field style="width: 125px; margin-right: 25px">
                  <mat-label>Etsi asiakas</mat-label>
                  <input #hakuInput type="text" [formField]="lomake.haku" matInput data-lpignore="true" />
                  @if (onkoVirhe(lomake.haku, 'required') && (lomake.haku().dirty() || lomake.haku().touched())) {
                    <mat-error> Haku puuttuu </mat-error>
                  }
                  @if (onkoVirhe(lomake.haku, 'minLenght') && (lomake.haku().dirty() || lomake.haku().touched())) {
                    <mat-error> Haku on liian lyhyt </mat-error>
                  }
                </mat-form-field>
                <mat-form-field style="width: 125px; margin-right: 25px">
                  <mat-label>Yhtiömuoto</mat-label>
                  <mat-select [formField]="lomake.yhtiomuoto">
                    <mat-option [value]="null"> </mat-option>
                    @for (yhtiomuoto of yritysmuodot; track yhtiomuoto) {
                      <mat-option [value]="yhtiomuoto.koodi">
                        {{ yhtiomuoto.nimi }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
              <div style="display: flex; justify-content: space-evenly; margin-top: 1em; margin-bottom: 2em">
                <app-secondary-button (click)="search()" actionId="Logit: hae asiakas">Hae asiakas</app-secondary-button>
              </div>
            </div>
          }

          <!--Asiakashaun tulokset-->
          @if (tulokset | async; as asiakkaat) {
            <div>
              <div style="font-size: 18px; margin-bottom: 20px; line-height: 20px; margin-top: 45px; text-align: center; color: #0a2731">Hakutulokset</div>
              @if (asiakkaat.length) {
                <table>
                  <tr>
                    <th>Nimi</th>
                    <th>Y-tunnus</th>
                    <th>Linkki</th>
                    <th>Valitse hakuun</th>
                  </tr>
                  @for (asiakas of asiakkaat; track asiakas) {
                    <tr>
                      <td>{{ asiakas.n }}</td>
                      <td>{{ asiakas.y }}</td>
                      <td><a [routerLink]="'/asiakkaat/' + asiakas.k + '/asiakastiedot'" [href]="'/asiakkaat/' + asiakas.k + '/asiakastiedot'" target="_blank">Asiakkaan tiedot</a></td>
                      <td>
                        <button class="secondarybutton" (click)="chooseCustomerForSearch(asiakas)" [ngClass]="{ 'selected-button': lomake.asiakasAvain().value() === asiakas.k }" [value]="asiakas" mat-button type="button">Valitse asiakas</button>
                        <!-- X
                        <app-secondary-button (click)="chooseCustomerForSearch(asiakas)" [dynamicClass]="{ 'selected-button': hakuform.get('asiakasAvain')?.value === asiakas.k }" actionId="Valitse asiakas logien hakuun">
                          Valitse asiakas 2
                        </app-secondary-button>-->
                      </td>
                    </tr>
                  }
                </table>
              } @else {
                <div style="padding: 3em">Antamillasi hakuehdoilla ei löytynyt yhtään asiakasta.</div>
              }
            </div>
          }
        </div>
      </div>
    </div>
  </form>

  <div style="width: 100%">
    <div>
      <mat-table [dataSource]="loggingEntries()" style="width: 100%">
        <!-- Kirjanpitäjä -->
        <ng-container matColumnDef="kirjanpitajaUid">
          <mat-header-cell *matHeaderCellDef style="min-width: 200px">Kirjanpitäjä</mat-header-cell>
          <mat-cell *matCellDef="let entry" style="min-width: 200px"> {{ entry.kirjanpitajaNimi }}</mat-cell>
        </ng-container>

        <!-- Asiakas -->
        <ng-container matColumnDef="asiakasAvain">
          <mat-header-cell *matHeaderCellDef style="min-width: 200px">Katsottu asiakas</mat-header-cell>
          <mat-cell *matCellDef="let entry" style="min-width: 200px">
            <a (click)="openCustomerLink(entry.asiakasAvain, $event)">
              {{ entry.asiakasNimi }}
            </a>
          </mat-cell>
        </ng-container>

        <!-- Event Type -->
        <ng-container matColumnDef="eventType">
          <mat-header-cell *matHeaderCellDef style="min-width: 150px">Tyyppi</mat-header-cell>
          <mat-cell *matCellDef="let entry" style="min-width: 150px">{{ entry.eventType }}</mat-cell>
        </ng-container>

        <!-- Event Name -->
        <ng-container matColumnDef="eventName">
          <mat-header-cell *matHeaderCellDef style="min-width: 200px">Tehty toiminto</mat-header-cell>
          <mat-cell *matCellDef="let entry" style="min-width: 200px">{{ entry.eventName }}</mat-cell>
        </ng-container>

        <!-- Navigation Method -->
        <ng-container matColumnDef="navigationMethod">
          <mat-header-cell *matHeaderCellDef style="min-width: 120px">Navigointityyli</mat-header-cell>
          <mat-cell *matCellDef="let entry" style="min-width: 120px">{{ entry.navigationMethod }}</mat-cell>
        </ng-container>

        <!-- Seen -->
        <ng-container matColumnDef="seen">
          <mat-header-cell class="custom-table" *matHeaderCellDef style="min-width: 200px">Katsottu sisältö</mat-header-cell>
          <mat-cell *matCellDef="let entry" style="min-width: 200px">{{ entry.seen }}</mat-cell>
        </ng-container>

        <!-- URL -->
        <ng-container matColumnDef="url">
          <mat-header-cell *matHeaderCellDef style="min-width: 200px">URL</mat-header-cell>
          <mat-cell *matCellDef="let entry" style="min-width: 200px">
            <a (click)="openUrl(entry.url, $event)" class="blue-link">
              {{ entry.url }}
            </a>
          </mat-cell>
        </ng-container>

        <!-- Timestamp -->
        <ng-container matColumnDef="timestamp">
          <mat-header-cell *matHeaderCellDef style="min-width: 200px">Aika</mat-header-cell>
          <mat-cell *matCellDef="let entry" style="min-width: 200px">{{ (entry.timestamp | date: 'medium') || '' }}</mat-cell>
        </ng-container>

        <!-- Log id generated by cloud logging -->
        <ng-container matColumnDef="insertId">
          <mat-header-cell *matHeaderCellDef style="min-width: 280px">Log id</mat-header-cell>
          <mat-cell *matCellDef="let entry" style="min-width: 280px">
            <a [href]="entry.logLink" target="_blank">{{ entry.insertId || '' }}</a>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row (click)="katsoTiedot(row)" [ngClass]="{ 'selected-row': selectedRow() === row }" *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>
    </div>
  </div>
  @if (commonError()) {
    <div class="red-text common-error" style="padding: 20px">{{ commonError() }}</div>
  }
</div>
